// Number / score formatting helpers. Outputs always use tabular-nums
// at the consuming component (`.mono` or `.tabular` class).

export function formatScore(n: number): string {
  if (n === 0) return '0.00';
  const sign = n > 0 ? '+' : '-';
  const abs = Math.abs(n).toFixed(2);
  return `${sign}${abs}`;
}

export function formatPct(n: number, digits = 0): string {
  return `${n.toFixed(digits)}%`;
}

export function clamp(n: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, n));
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function relativeDate(iso: string): string {
  const then = new Date(iso).getTime();
  const now = Date.now();
  const diff = now - then;
  const day = 1000 * 60 * 60 * 24;
  if (diff < day) return 'Today';
  if (diff < day * 2) return 'Yesterday';
  if (diff < day * 7) return `${Math.floor(diff / day)} days ago`;
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
